import plusImg from "../picture/Plus.png";
import messageImg from "../picture/Message.png";
import penImg from "../picture/Pen.png";
import categoriesImg from "../picture/Category.png";
import imagesImg from "../picture/slika.png";
import linkPictureImg from "../picture/LinkWWW.png";
import documentImg from "../picture/Document.png";
import attachImg from "../picture/Prilog.png";
import visibleImg from "../picture/Visible.png";
import blackMailUserImg from "../picture/BlackMailUser.png";
import whiteMailUserImg from "../picture/WhiteMailUser.png";
import text5Img from "../picture/text5.png";
import Button from "../AdminPanel/Custom/Button/Button.jsx";

const SettingsEditorSegment8 = ({ data, handleCheckboxChange }) => {

  if (!data) return null

  return (
    <div style={{display: "flex", gap: "30px"}}>
      <div className="se-segment8">
        <div className="se-segment8-item">
          <div className="se-segment8-item-row1">
            <div className="se-segment8-item-naslov">36.</div>
            <div>Email adresa ili ime kreatora</div>
            <div>08:45</div>
          </div>
          <div className="se-segment8-item-row2">
            <div className="se-segment8-item-naslov">NASLOV NOVE STAVKE</div>
            <div>11:10</div>
          </div>
          <div className="se-segment8-item-row3">
            <img src={messageImg} style={{width: "20px", height: "20px"}}/>
            <div>1</div>
          </div>
        </div>

        <div className="se-segment3-1" style={{fontSize: "18px"}}>
            <div className="se-segment3-1-header">XXXXXXXX</div>
            <div className="se-segment3-1-content">
              <div>Xxxxx xxx xxxx xx xxxxxxxx xx</div>
              <div>xxxxx. Xxxxxxxx xxxx</div>
            </div>
        </div>

        <div className="se-segment7-buttons" style={{height: "70px"}}>
          <Button style={{width: "20%", position: "relative", opacity: data.allow_edit === false ? 0.5 : 1}}>
            <img src={penImg}/>
            <div className="se-segment6-buttons-circle">32</div>
          </Button>
          <Button style={{width: "20%", position: "relative", opacity: data.hide_item === false ? 0.5 : 1}}>
            <img src={visibleImg}/>
            <div className="se-segment6-buttons-circle">33</div>
          </Button>
          <Button style={{width: "20%"}}>
            <img src={categoriesImg}/>
          </Button>
          <Button style={{width: "20%"}}>
            <img src={imagesImg}/>
          </Button>
          <Button style={{width: "20%"}}>
            <img src={attachImg}/>
          </Button>
        </div>

        <div className="se-segment7-buttons" style={{marginTop: "10px", height: "70px"}}>
          <Button style={{width: "20%"}}>
            <img src={categoriesImg}/>
          </Button>
          <Button style={{width: "20%"}}>
            <img src={imagesImg}/>
          </Button>
          <Button style={{width: "20%"}}>
            <img src={attachImg}/>
          </Button>
          <Button style={{width: "40%", position: "relative", display: "flex", opacity: data.comment_item ? 1 : 0.5}}>
            <img src={penImg}/>
            <img src={messageImg}/>
            <div className="se-segment6-buttons-circle">34</div>
          </Button>
        </div>

        <div className="se-segment7-row1">
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="allow_edit"
              checked={data.allow_edit}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">32</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="hide_item"
              checked={data.hide_item}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">33</div>
          </div>
          <div className="one-checbox" style={{width: "20%"}}></div>
          <div className="one-checbox" style={{width: "20%"}}></div>
          <div className="one-checbox" style={{width: "20%"}}>
            <input type="checkbox"
              name="comment_item"
              checked={data.comment_item}
              onChange={handleCheckboxChange}
            />
            <div className="num-checkbox">34</div>
          </div>
        </div>

        <div className="se-segment7-row2" style={{marginBottom: "10px"}}>
          <div className="one-checbox">
            <img src={plusImg} style={{width: "24px", height: "24px"}}/>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="comment_image"
              checked={data.comment_image}
              onChange={handleCheckboxChange}
            />
            <img src={imagesImg} style={{width: "24px", height: "24px"}}/>
          </div>
          <div className="one-checbox">
            <input type="checkbox"
              name="comment_doc"
              checked={data.comment_doc}
              onChange={handleCheckboxChange}
            />
            <img src={documentImg} style={{width: "24px", height: "24px"}}/>
          </div>
           <div className="one-checbox">
            <input type="checkbox"
              name="comment_link"
              checked={data.comment_link}
              onChange={handleCheckboxChange}
            />
            <img src={linkPictureImg} style={{width: "24px", height: "24px"}}/>
          </div>
           <div className="one-checbox">
            <input type="checkbox"
              name="comment_internal_user"
              checked={data.comment_internal_user}
              onChange={handleCheckboxChange}
            />
            <img src={blackMailUserImg} style={{width: "40px", height: "24px"}}/>
          </div>
           <div className="one-checbox">
            <input type="checkbox"
              name="comment_external_user"
              checked={data.comment_external_user}
              onChange={handleCheckboxChange}
            />
            <img src={whiteMailUserImg} style={{width: "40px", height: "24px"}}/>
          </div>
        </div>
      </div>
      <div style={{display: "flex", alignItems: "center"}}>
        <img src={text5Img} style={{width: "100%", height: "120px"}}/>
      </div>
    </div>
  );
};

export default SettingsEditorSegment8;